import zielbildung from '../../../../../assets/image/naw/promo/zielbildung.png'
import planungUmsetzung from '../../../../../assets/image/naw/promo/planungUmsetzung.png'
import nutzerbedarfsanalyse from '../../../../../assets/image/naw/promo/nutzerbedarfsanalyse.png'
import changeManagement from '../../../../../assets/image/naw/promo/changeManagement.png'
import qr from '../../../../../assets/image/naw/promo/qr.png'
import referenzes from '../../../../../assets/image/naw/promo/referenzes.png'
import daniel from '../../../../../assets/image/naw/promo/daniel.png'
import HeadlineSplit from '../HeadlineSplit'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import Button from '../../../../UI/Button/Button'
import { ArrowDownOnSquareIcon, CalendarDaysIcon, DevicePhoneMobileIcon, EnvelopeIcon, HomeIcon } from '@heroicons/react/24/outline'
import { FullHeightContentWrapper } from '../PageList'
import GoBack from '../GoBack/GoBack'
import { NAWSurvey } from '../../../../../types/NAW/Survey'
import useGetResultExport from './useGetResultExport'

const PropItem = ({ img, text }) => {
  return (
    <div className="flex flex-1 items-center gap-5">
      <img src={img} alt="zielbildung" className="h-12 md:h-16" />
      <div className="md:text-[1.5rem] text-black" dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  )
}

const CTAItem: React.FC<{
  Icon: any
  text: string
  href?: string
  onClick?: () => void
  contrast?: boolean
  invert?: boolean
  className?: string
  disabled?: boolean
}> = ({ Icon, text, href, onClick, contrast = false, invert = false, className = '', disabled = false }) => {
  return (
    <div className="flex gap-3 items-center">
      {Icon}
      <Button
        className={`${className} text-nowrap border-black ${
          contrast
            ? '!bg-lightGray !text-black hover:!text-black'
            : invert
            ? '!bg-white !text-black'
            : '!bg-green !text-white !border-green hover:!bg-white hover:!text-green'
        }`}
        disabled={disabled}
        text={text}
        href={href}
        newTab={true}
        onClick={onClick}
      />
    </div>
  )
}

const Promo: React.FC<{ survey: NAWSurvey; backToFlaeche: () => void }> = ({ survey, backToFlaeche }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [generateExportResult, isLoading] = useGetResultExport(survey)

  return (
    <FullHeightContentWrapper className="!py-0 !px-3">
      <div className="flex flex-col gap-5 h-full pt-8">
        <GoBack onClick={backToFlaeche} />
        <div className="flex flex-col md:flex-row gap-10 h-full pb-0 md:pb-6">
          <div className="md:w-4/6 h-full flex flex-col justify-between">
            <div className="flex flex-col">
              <HeadlineSplit
                suffix={t.naw.survey.answer.promo.prefix}
                dynamicSuffix={t.naw.survey.answer.promo.dynamicSuffix}
                dynamicSuffixClassName="!text-[1.5rem] md:!text-xl"
                glue=" "
              />
              <div className="flex-col gap-10 mt-10 md:mt-16 hidden md:flex">
                <div className="flex flex-col md:flex-row gap-10">
                  <PropItem img={zielbildung} text={t.naw.survey.answer.promo.zielbildung} />
                  <PropItem img={planungUmsetzung} text={t.naw.survey.answer.promo.planungUmsetzung} />
                </div>
                <div className="flex flex-col md:flex-row gap-10">
                  <PropItem img={nutzerbedarfsanalyse} text={t.naw.survey.answer.promo.nutzerbedarfsanalyse} />
                  <PropItem img={changeManagement} text={t.naw.survey.answer.promo.changeManagement} />
                </div>
              </div>
              <div className="flex flex-col gap-10 mt-10 md:mt-16 md:hidden">
                <div className="flex flex-col md:flex-row gap-10">
                  <PropItem img={zielbildung} text={t.naw.survey.answer.promo.zielbildung} />
                  <PropItem img={nutzerbedarfsanalyse} text={t.naw.survey.answer.promo.nutzerbedarfsanalyse} />
                  <PropItem img={planungUmsetzung} text={t.naw.survey.answer.promo.planungUmsetzung} />
                  <PropItem img={changeManagement} text={t.naw.survey.answer.promo.changeManagement} />
                </div>
              </div>
            </div>
            <div className="flex-col md:flex-row gap-10 mt-10 hidden md:flex">
              <div className="flex-1 flex flex-col">
                <div className="text-lg md:text-xl leading-8 text-black">{t.naw.survey.answer.promo.video.prefix}</div>
                <HeadlineSplit suffix={t.naw.survey.answer.promo.video.suffix} />
                <video className="w-full mt-5" controls src={t.naw.survey.answer.promo.video.src} />
              </div>
              <div className="flex-1 flex flex-col">
                <div className="text-lg md:text-xl leading-8 text-black">{t.naw.survey.answer.promo.references.prefix}</div>
                <HeadlineSplit suffix={t.naw.survey.answer.promo.references.suffix} />
                <a href="https://www.mps-archonic.com/referenzen/" rel="noreferrer" target="_blank">
                  <img className="w-full object-cover aspect-video mt-5" src={referenzes} alt="Referenzen" />
                </a>
              </div>
            </div>
          </div>
          <div className="md:w-2/6 flex flex-col justify-between gap-5">
            <div className="flex flex-col-reverse md:flex-col justify-between gap-5">
              <div className="flex flex-col gap-5 mt-10 md:mt-0">
                {t.naw.survey.answer.promo.text.map((t, i) => (
                  <div key={i} className={`text-black xl:text-lg ${i === 0 && 'font-bold'}`}>
                    {t}
                  </div>
                ))}
              </div>
              <div className="flex gap-5">
                <div className="flex flex-col gap-1 w-full mt-0 xl:mt-8">
                  <CTAItem
                    Icon={<CalendarDaysIcon className="w-7 md:w-8 stroke-black" />}
                    href={`https://calendly.com/daniel-kretz-mps-archonic/erstgesprach-zu-neuen-arbeitswelten-klon`}
                    className="w-full"
                    text={t.naw.survey.answer.promo.cta.meeting}
                  />
                  <CTAItem
                    contrast
                    Icon={<ArrowDownOnSquareIcon className="w-7 md:w-8 stroke-black" />}
                    className="w-full"
                    text={t.naw.survey.answer.promo.cta.download}
                    onClick={generateExportResult}
                    disabled={isLoading}
                  />
                  <CTAItem
                    Icon={<EnvelopeIcon className="w-7 md:w-8 stroke-black" />}
                    invert
                    className="!border !border-blue w-full"
                    text={t.naw.survey.answer.promo.cta.mail}
                    href="mailto:daniel.kretz@mps-archonic.com"
                  />
                  <CTAItem
                    Icon={<DevicePhoneMobileIcon className="w-7 md:w-8 stroke-black" />}
                    invert
                    className="!border !border-blue w-full"
                    text={t.naw.survey.answer.promo.cta.phone}
                    href={`tel:${t.naw.survey.answer.promo.cta.phone}`}
                  />
                  <CTAItem
                    Icon={<HomeIcon className="w-7 md:w-8 stroke-black" />}
                    invert
                    className="!border !border-blue w-full"
                    text={t.naw.survey.answer.promo.cta.homepage}
                    href="https://www.mps-archonic.com/leistungen/neue-arbeitswelten/"
                  />
                </div>
                <div className="items-end justify-end hidden md:flex">
                  <img className="w-2/3 min-w-24" src={qr} alt="QR-Code" />
                </div>
              </div>
            </div>
            <div className="relative">
              <a href="https://www.linkedin.com/in/daniel-kretz-529927127/" target="_blank" rel="noreferrer">
                <img className="w-full mt-5" src={daniel} alt="Daniel" />
              </a>
              <div className="bg-blue w-full md:absolute -bottom-3 left-2/3 p-2 md:p-3 px-5 md:px-10 flex md:block flex-row md:flex-col items-center gap-3">
                <div className="text-white text-lg md:text-xl font-thin leading-7">
                  {t.naw.survey.answer.promo.daniel.firstname}
                  <span className="font-swear-display text-white">{t.naw.survey.answer.promo.daniel.lastname}</span>
                </div>
                <div className="text-white font-thin text-sm md:hidden">{' - '}</div>
                <div className="text-white font-thin text-sm">{t.naw.survey.answer.promo.daniel.position}</div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-10 mt-10 md:hidden">
              <div className="flex-1 flex flex-col">
                <div className="text-lg md:text-xl leading-8">{t.naw.survey.answer.promo.video.prefix}</div>
                <HeadlineSplit suffix={t.naw.survey.answer.promo.video.suffix} />
                <video className="w-full mt-5" controls src={t.naw.survey.answer.promo.video.src} />
              </div>
              <div className="flex-1 flex flex-col">
                <div className="text-lg md:text-xl leading-8">{t.naw.survey.answer.promo.references.prefix}</div>
                <HeadlineSplit suffix={t.naw.survey.answer.promo.references.suffix} />
                <a href="https://www.mps-archonic.com/referenzen/" rel="noreferrer" target="_blank">
                  <img className="w-full object-cover aspect-video mt-5" src={referenzes} alt="Referenzen" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FullHeightContentWrapper>
  )
}

export default Promo
